import { EnvironmentProviders, Provider, makeEnvironmentProviders } from '@angular/core';

import { CamWebPushConfig } from './services/dto/web-push';
import { CAM_WEB_PUSH_CONFIG } from './services/web-push.service';

export function provideCamWebPush(config: CamWebPushConfig): EnvironmentProviders {
  const providers: Provider[] = [{ provide: CAM_WEB_PUSH_CONFIG, useValue: config }];
  return makeEnvironmentProviders(providers);
}
